angular.module('LeasePilot').factory('CurrentUserService', [
  'railsResourceFactory',
  function(railsResourceFactory) {
    return railsResourceFactory({
      url: '/get_current_user',
      name: 'user',
    });
  },
]);
